<template>
  <div>
    <!-- 开票列表弹框 -->
    <el-dialog
      title="开票列表"
      :visible.sync="dialogVisible"
      width="80%"
      :close-on-click-modal="false"
      @close="handleClose">

      <div v-loading="loading">
        <el-table :data="invoiceList" border>
          <el-table-column prop="invoice_type" label="类型" align="center" width="120"></el-table-column>
          <el-table-column prop="ticket_no" label="发票号" align="center" width="150"></el-table-column>
          <el-table-column prop="amount" label="开票金额" align="center" width="120">
            <template slot-scope="scope">
              {{ formatAmount(scope.row.amount) }}
            </template>
          </el-table-column>
          <el-table-column prop="invoice_time" label="开票日期" align="center" width="120">
            <template slot-scope="scope">
              {{ formatDate(scope.row.invoice_time) }}
            </template>
          </el-table-column>
          <el-table-column label="是否审核" align="center" width="100">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.check_status > 0 ? 'success' : 'warning'">
                {{ scope.row.check_status > 0 ? '已审核' : '未审核' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center" min-width="150">
            <template slot-scope="scope">
              {{ scope.row.remarks || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="viewInvoiceDetail(scope.row)">
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div v-if="!invoiceList || invoiceList.length === 0" style="text-align: center; padding: 40px; color: #999;">
          暂无开票记录
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 发票详情弹框 -->
    <el-dialog
      title="发票详情"
      :visible.sync="detailVisible"
      width="700px"
      :close-on-click-modal="false">

      <div v-loading="detailLoading">
        <el-descriptions :column="2" border v-if="invoiceDetail">
          <el-descriptions-item label="发票类型">
            {{ invoiceDetail.invoice_type || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="发票号码">
            {{ invoiceDetail.ticket_no || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="开票金额">
            <span style="color: #f56c6c; font-weight: bold;">
              {{ formatAmount(invoiceDetail.amount) }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="开票日期">
            {{ formatDate(invoiceDetail.invoice_time) }}
          </el-descriptions-item>
          <el-descriptions-item label="审核状态">
            <el-tag :type="invoiceDetail.check_status > 0 ? 'success' : 'warning'">
              {{ invoiceDetail.check_status > 0 ? '已审核' : '未审核' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="收款状态">
            <el-tag :type="invoiceDetail.is_paid > 0 ? 'success' : 'info'">
              {{ invoiceDetail.is_paid > 0 ? '已收款' : '未收款' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="客户名称" :span="2">
            {{ invoiceDetail.party_a || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="项目名称" :span="2">
            {{ invoiceDetail.project_name || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="业务类型" :span="2">
            {{ invoiceDetail.entry_type_name || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="应收月份" :span="2">
            {{ invoiceDetail.month || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="合同金额" :span="2">
            {{ formatAmount(invoiceDetail.contract_amount) }}
          </el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">
            {{ invoiceDetail.remarks || '-' }}
          </el-descriptions-item>
        </el-descriptions>

        <!-- 附件展示 -->
        <div v-if="invoiceDetail && invoiceDetail.files" style="margin-top: 20px;">
          <div style="font-weight: bold; margin-bottom: 10px;">附件：</div>
          <div v-for="(file, index) in parseFiles(invoiceDetail.files)" :key="index" style="margin-bottom: 8px;">
            <el-link
              type="primary"
              :href="file.url"
              target="_blank"
              :underline="false">
              <i class="el-icon-document"></i> {{ file.name }}
            </el-link>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonHelp from "../common/CommonHelp";
import Api from "../common/Api";

export default {
  name: "InvoiceDetailDialog",
  data() {
    return {
      dialogVisible: false,
      detailVisible: false,
      loading: false,
      detailLoading: false,
      financeId: null,
      invoiceList: [],
      invoiceDetail: null
    };
  },
  methods: {
    // 打开弹框
    open(financeId) {
      this.financeId = financeId;
      this.dialogVisible = true;
      this.loadInvoiceList();
    },

    // 加载开票列表
    loadInvoiceList() {
      if (!this.financeId) {
        this.$message.warning('费项ID不能为空');
        return;
      }

      this.loading = true;
      Api.invoiceList(
        { id: this.financeId },
        1,
        100,
        (res) => {
          this.invoiceList = res.list || [];
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    },

    // 查看发票详情
    viewInvoiceDetail(row) {
      this.detailLoading = true;
      this.detailVisible = true;

      // 获取发票详细信息
      CommonHelp.get("FinanceInvoice/getDetail", { id: row.id }, res => {
        this.detailLoading = false;
        if (res.code === 1) {
          this.invoiceDetail = res.data;
        } else {
          this.$message.error(res.msg || '获取发票详情失败');
        }
      });
    },

    // 关闭弹框
    handleClose() {
      this.invoiceList = [];
      this.invoiceDetail = null;
      this.financeId = null;
    },

    // 格式化金额
    formatAmount(amount) {
      if (!amount && amount !== 0) return '-';
      return parseFloat(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '-';
      
      // 如果是字符串，尝试解析
      if (typeof timestamp === 'string') {
        // 如果已经是格式化的日期字符串，直接返回
        if (timestamp.includes('-') || timestamp.includes('/')) {
          return timestamp;
        }
        // 尝试转换为数字
        timestamp = parseInt(timestamp);
      }
      
      // 如果是数字，判断是秒级还是毫秒级时间戳
      if (typeof timestamp === 'number') {
        // 如果时间戳小于 10000000000，说明是秒级，需要转换为毫秒级
        if (timestamp < 10000000000) {
          timestamp = timestamp * 1000;
        }
        
        // 使用 JavaScript Date 对象格式化
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
      
      return '-';
    },

    // 解析附件
    parseFiles(filesStr) {
      if (!filesStr) return [];
      try {
        const files = typeof filesStr === 'string' ? JSON.parse(filesStr) : filesStr;
        return Array.isArray(files) ? files.map(file => ({
          name: file.name || file.file_name || '附件',
          url: file.path || file.file_path || file.url || ''
        })) : [];
      } catch (e) {
        console.error('解析附件失败:', e);
        return [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-descriptions-item__label {
  font-weight: bold;
  background-color: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/components/InvoiceDetailDialog.vue